import React from 'react';
import {
  ApplicationView,
  ControlledComponent,
  StartControllerScope,
  useController,
} from '@aha-app/mvc';
import WidgetsController from '../../../controllers/WidgetsController';
import VotingSessionController from './controllers/VotingSessionController';
import classNames from 'classnames';
import styles from './VotingSession.module.css';
import type { WhiteboardSidePanelItem } from '../../../sidepanel-types';
import VotingSetupForm from './VotingSetupForm';
import Details from './Details';
import ResultsList from './ResultsList';
import InlineEditable from './InlineEditable';

// Create a wrapper that initializes the VotingSessionController with
// the VotingSessionWidget.
const VotingSessionContainer: React.FC = () => {
  const widgetsController = useController(WidgetsController);
  const widget = widgetsController.activeVotingSessionWidget;

  return <ControlledSidePanelComponent widget={widget} />;
};

const VotingSessionPanel: React.FC = () => {
  const controller = useController(VotingSessionController);

  const { widget } = controller.state;
  const { name, finishedWidgets } = controller;

  const hasResults = finishedWidgets.length > 0;

  const item: WhiteboardSidePanelItem = {
    id: 'votingResults',
    name: 'Voting results',
    icon: 'aha-icon aha-icon-voting',
    content: (
      <ControlledComponent controller={controller}>
        <ResultsList />
      </ControlledComponent>
    ),
  };

  return (
    <>
      <div className='side-panel__header'>
        <div className='side-panel__title align-items-baseline'>
          <h3 className={classNames('h-500', 'side-panel__title-text')}>
            <InlineEditable
              value={name}
              onChange={value => controller.actionSetName(value)}
            />
          </h3>
          {hasResults && (
            <aha-button
              class={styles.resultsButton}
              kind='ghost'
              onClick={() => controller.actionPushSidePanel(item)}
            >
              Results
              <aha-icon
                icon='fa-regular fa-square-poll-vertical'
                class='ml-1'
              />
            </aha-button>
          )}
        </div>
      </div>
      <div className='side-panel__content sidepanel-scroll-parent'>
        <div className={styles.height100Percent}>
          {widget ? <Details widget={widget} /> : <VotingSetupForm />}
        </div>
      </div>
    </>
  );
};

const ControlledSidePanelComponent = StartControllerScope(
  VotingSessionController,
  ApplicationView(VotingSessionPanel)
);

export default ApplicationView(VotingSessionContainer);
